const data = [
    { id: 1, name: "ENTRADA" },
    { id: 2, name: "SAÍDA" },
    { id: 3, name: "PERSONALIZADO" },
]

export default [...data]